import { createTheme } from "@mui/material/styles";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    reject: true;
  }
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    page_title: React.CSSProperties;
    modal_title: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    page_title?: React.CSSProperties;
    modal_title: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    modal_title: true;
    page_title: true;
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: "#08705f",
    },
  },
  typography: {
    page_title: {
      fontSize: 22,
      fontWeight: 600,
      color: "var(--black10)",
      // textTransform: "capitalize",
      fontFamily: "FSAlbertPro !important",
    },
    modal_title: {
      fontSize: 24,
      fontWeight: 600,
      color: "var(--black10)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: 45,
          fontWeight: 700,
          fontSize: "18px",
          borderRadius: 8,
          boxShadow: "none",
          padding: "0 25px",
          textTransform: "inherit",
          "&:hover": {
            opacity: 0.9,
            boxShadow: "none",
          },
          "&.Mui-disabled": {
            color: "white",
            background: "var(--gray)",
            "&:hover": {
              color: "white",
              background: "var(--gray)",
            },
          },
        },
      },
      variants: [
        {
          props: { variant: "contained" },
          style: {},
        },
        {
          props: { variant: "text" },
          style: {
            color: "var(--gray30)",
            background: "transparent",
            "&:hover": {
              border: "none",
              color: "var(--gray30)",
            },
          },
        },
        {
          props: { variant: "reject" },
          style: {
            color: "white",
            backgroundColor: "var(--red)",
            "&:hover": {
              color: "white",
              backgroundColor: "var(--red)",
            },
          },
        },
      ],
    },
    MuiSelect: {
      styleOverrides: {
        // root: {},
        select: {
          padding: "10px 14px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "10px !important",
          backgroundColor: "white",
          ":has(.MuiInputAdornment-positionStart)": {
            paddingLeft: "20px !important",
            input: {
              paddingLeft: "0 !important",
            },
          },
          ":has(.MuiInputAdornment-positionEnd)": {
            paddingRight: "15px !important",

            input: {
              paddingRight: "0 !important",
            },
          },
          input: {
            padding: "10px 20px !important",
          },
        },
        input: {
          "::placeholder": {
            opacity: 1,
            fontSize: 16,
            fontWeight: 400,
            color: "var(--gray10)",
          },
        },
        sizeSmall: {
          height: 45,
          input: {
            padding: "10px 14px !important",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginTop: "10px !important",
        },
      },
    },
    MuiTextField: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {
            root: {
              backgroundColor: "white !important",
            },
            "& .MuiOutlinedInput-root.Mui-error  .MuiOutlinedInput-notchedOutline":
              {
                border: "1px solid var(--red)",
                boxShadow: "0px 0px 0px 1px var(--red)",
              },
          },
        },
      ],
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: "white",
          "& fieldset": {
            borderColor: "var(--gray20)",
          },
        },
      },
    },
  },
});
